import React from "react";
import "./index.scss";
import Opportunities from "../../components/Rejoignez/Opportunities";
import JoinSection from "../../components/Rejoignez/JoinSection";
import CandidatureSection from "../../components/Rejoignez/CandidatureSection";
import Header from "../../components/appLayout/header";
import SEO from "../../components/SEO";
import hazelcast from "../../assets/images/hazelcast.png";
import bright from "../../assets/images/bright.png";
import obsidian from "../../assets/images/obsidian.png";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import client1 from "../../assets/images/c1.png";

import client2 from "../../assets/images/c2.png";
import client3 from "../../assets/images/c3.png";
import client4 from "../../assets/images/c4.png";
import client5 from "../../assets/images/c5.png";
import client6 from "../../assets/images/c6.png";
import client7 from "../../assets/images/c7.png";
import client8 from "../../assets/images/c8.png";
import client9 from "../../assets/images/c9.png";

export const RejoignezPage = () => {
  const { t } = useTranslation();
  const settingsRow1 = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 3, // Nombre d'images visibles en même temps
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear",
    arrows: false, // Direction de droite à gauche
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1300, // En dessous de 768px (mobile)
        settings: {
          slidesToShow: 2, // Affiche 3 drapeaux
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // En dessous de 768px (mobile)
        settings: {
          slidesToShow: 3, // Affiche 3 drapeaux
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // En dessous de 480px (petit mobile)
        settings: {
          slidesToShow: 2, // Affiche 2 drapeaux
          slidesToScroll: 1,
        },
      },
    ],
  };
  const rows1 = [
    { id: 1, image: client1, alt: " brand 1" },
    { id: 2, image: client2, alt: " brand 2" },
    { id: 3, image: client3, alt: "brand 3" },
    { id: 4, image: client4, alt: "brand 4" },
    { id: 5, image: client5, alt: "brand 5" },
    { id: 6, image: client6, alt: " brand 1" },
    { id: 7, image: client7, alt: " brand 2" },
    { id: 8, image: client8, alt: "brand 3" },
    { id: 9, image: client9, alt: "brand 4" },
  ];
  return (
    <div>
      <SEO
        title="Rejoignez MSIT Conseil - Carrières et Opportunités"
        description="Rejoignez l'équipe MSIT Conseil. Découvrez nos offres d'emploi et opportunités de carrière dans le conseil, la transformation digitale, l'IA et les services technologiques."
        keywords="carrières MSIT, emploi MSIT, recrutement MSIT, offres d'emploi conseil, rejoindre MSIT"
        url="https://www.msit-conseil.fr/rejoignez-msit"
        breadcrumbs={[
          { name: "Accueil", url: "https://www.msit-conseil.fr/" },
          { name: "Rejoignez MSIT", url: "https://www.msit-conseil.fr/rejoignez-msit" }
        ]}
      />
      <Header />
      <JoinSection />
      <div className="trusted1 mt-5 d-md-none d-block">
        <p className="trusted-text">{t("join.trustedBy")}</p>
        <div className="logos d-flex align-items-center gap-4 flex-wrap mt-3 justify-content-center mb-4">
          <div className="row ms-0  gx-0 w-100">
            <div className="col-12 col-md-8 w-100">
              <Slider {...settingsRow1}>
                {rows1.map((row) => (
                  <div key={row.id} className="row-slider3">
                    <img src={row.image} alt={row.alt} />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <Opportunities />
      <CandidatureSection />
    </div>
  );
};
